// extracted by mini-css-extract-plugin
export default {"icon":"LanguageSelect-module_icon_zSSOMt"};